module.exports = __webpack_public_path__ + "img/sw2-qr.a0df93e5.jpg";